import React from 'react';
import Immutable from 'immutable';

import { Container, WysiwygField } from '@uncinc/uncinc-react-kitchen-sink';
import { Paragraph } from '@uncinc/react-drupal-core';


import './style.scss';
import Header from '../Header';

const ThemeItem = ({ introTitle, entity }) => {
  return (
    <div className="ThemeItem">
      <Container>
        <Header blue introTitle={introTitle} />
        <div className="ThemeItem__content">
          <div className="row">
            <div className="col-12 col-md-8 offset-md-2">
              <div className="ThemeItem__intro">
                <div className="col-12">
                  <h1>{ entity.getIn(['field_title', 0, 'value']) }</h1>
                  <WysiwygField
                    html={entity.getIn(['field_body', 0, 'value'], '')}
                  />
                </div>
              </div>
              <div className="ThemeItem__paragraphs">
                {entity.get('field_paragraphs', Immutable.List()).map((paragraph) => {
                  const id = paragraph.get('target_id');
                  const language = paragraph.getIn(['entity', 'langcode', 0, 'value']);
                  return (
                    <Paragraph
                      key={`paragraph:${id}:${language}`}
                      id={id}
                      entity={paragraph.get('entity')}
                    />
                  );
                })}
              </div>
            </div>
          </div>
        </div>
      </Container>
    </div>
  );
};

export default ThemeItem;
